import React from 'react';

/**
 * Fonction pour formater chaque règle d'une préalerte en HTML
 * Map sur les règles pour générer le rendu HTML
 * Effectue un Switch pour traiter chaque opérateur
 * Puis le rendu du paragraphe pour chaque règle
 * @param {*} param0 
 * @returns 
 */
const PreAlertRuleFormatter = ({ rules, contextDetails }) => {
    
    const formatRule = (rule) => {
    const { champ, operateur, valeur } = rule;
    const label = contextDetails.data[champ]?.description ?? champ;
    let formattedValue;

    switch (operateur) {
        case '>=':
            formattedValue = (
                <>
                <span className="rule-value">{label}</span> {' supérieur ou égal à '} <span className="rule-value">{valeur}</span>
                </>
            );
            break;
        case '>':
            formattedValue = (
                <>
                <span className="rule-value">{label}</span> {' supérieur à '} <span className="rule-value">{valeur}</span>
                </>
            );
            break;
        case '=':
            formattedValue = (
                <>
                <span className="rule-value">{label}</span> {' égal à '} <span className="rule-value">{valeur}</span>
                </>
            );
            break;
        case '<':
            formattedValue = (
                <>
                <span className="rule-value">{label}</span> {' inférieur à '} <span className="rule-value">{valeur}</span>
                </>
            );
            break;
        case '<=':
            formattedValue = (
                <>
                <span className="rule-value">{label}</span> {' inférieure ou égale à '} <span className="rule-value">{valeur}</span>
                </>
            );
            break;
        case 'compris entre':
        case 'between':
            const [min, max] = valeur;
            formattedValue = (
                <>
                <span className="rule-value">{label}</span>{ ' compris entre '} <span className="rule-value">{min}</span> {' et '} <span className="rule-value">{max}</span>
                </>
            );
            break;
        case 'Nulle':
            formattedValue = (
                <>
                <span className="rule-value">{label}</span> {' est nul(le)'}
                </>
            );
        break;
        default:
            formattedValue = null;
    }

    return (
        <div key={`${champ}-${operateur}-${valeur}`}>
            {formattedValue}
        </div>
    );
  };

  return <div className="rules">{rules.map(formatRule)}</div>;
};

export default PreAlertRuleFormatter;
